module.exports = __webpack_public_path__ + "img/deporte.0e1e8536.webp";